import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { NotFound } from '../../../pages/NotFound/NotFound';
import { taskEntered } from '../../../features/operator/operatorDeviceSlice';
import { OPERATOR_SCREEN } from '../../../features/operator/operatorConstants';

/**
 * An address the operator's workspace does not have. A screen of its own:
 * what answers for the task left behind is named after it, as anywhere else.
 */
export const OperatorNotFound = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(taskEntered({ flow: OPERATOR_SCREEN.NOT_FOUND }));
  }, [dispatch]);

  return <NotFound />;
};
